import React from "react";
import Widget from "../../../../components/BetterWidget";
import {Button, Grid, TextField, Typography, useTheme, makeStyles} from "@material-ui/core";
import Rest from "../../../../helpers/Rest";
import Credentials from "../Credentials";
import {toast} from "react-toastify";

const useStyle = makeStyles(theme => {
    return {
        root:{
            paddingBottom: theme.spacing(2),
            width: "100%",
            "& h3":{
                color: theme.palette.text.disabled,
                margin: theme.spacing(1, 0),
                "& button":{
                    float: "right"
                }
            },
            "& > div":{
                width:"100%"
            }
        }
    }
})

const DISCONNECTED = 0, CONNECTING = 1, CONNECTED = 2

class Connection extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            command: '',
            responses: '',
            state: DISCONNECTED,
            exporting: false
        }
        this.logRef = React.createRef()
        this.updateCommand = e => this.setState({
            command: e.target.value
        })
        this.sendCommand = () => {
            if (this.reconnector){
                return
            }
            this.socket.send(JSON.stringify({m: this.state.command}))
            this.setState({
                command: ''
            })
            this.log(`\n#> ${this.state.command}\n`)
        }
        this.scrollToBottom = () => {
            const {current} = this.logRef
            current.scrollTop = current.scrollHeight
        }
        this.gotResponse = message => this.log(message.data)
        const close = () => this.socket.close()
        this.buttonStates = [
            {
                label: "Connect",
                action: () => this.openWebSocket()
            },
            {
                label: "Cancel",
                action: close
            },
            {
                label: "Disconnect",
                action: close
            }
        ]
        this.exportLogs = () => {
            this.setState({exporting: true})
            Rest.getBinary(`device/${this.props.deviceId}/tcp-sessions/export`).then(blob => {
                const deviceCode = (this.props.deviceCode || this.props.deviceName || 'device')
                    .replace(/[^A-Za-z0-9._-]/g, '_')
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.download = `${deviceCode}_tcp_sessions.zip`
                link.href = url
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)
            }).catch(error => {
                if (error === 'No TCP log sessions found for this device'){
                    toast.info('No TCP logs are available for this device')
                }
                else {
                    toast.error(`Unable to export TCP logs: ${error}`)
                }
            }).then(() => this.setState({exporting: false}))
        }
    }

    clearReconnect(){
        if (this.reconnector){
            clearTimeout(this.reconnector)
            this.reconnector = null
        }
    }

    reconnect(message){
        this.clearReconnect()
        //this.reconnector = setTimeout(() => this.openWebSocket(), 1000)
        this.setState({
            state: DISCONNECTED,
            responses: message
        })
    }

    log(message){
        this.setState({
            responses: this.state.responses + message
        })
        this.scroller = setTimeout(this.scrollToBottom, 50)
    }

    openWebSocket(){
        this.socket = new WebSocket(Rest.wsOrigin + "/api/commands/" + this.props.deviceId);
        this.socket.addEventListener("open", () => {
            this.clearReconnect()
            this.pingHandler = setInterval(() => {
                this.socket.send('{"m":null}')
            }, 10000)
            this.log("\nConnected")
            this.setState({
                state: CONNECTED
            })
        })
        this.setState({
            state: CONNECTING
        })
        this.socket.addEventListener("message", this.gotResponse)
        this.socket.addEventListener("close", () => this.reconnect("The device has disconnected"))
        this.socket.addEventListener("error", () => this.reconnect("The device is not currently connected"))
    }

   /* componentDidMount() {
        this.openWebSocket()
    }*/

    clear(){
        this.clearReconnect()
        if (this.pingHandler){
            clearInterval(this.pingHandler)
            this.pingHandler = null
        }
        if (this.socket){
            this.socket.close()
            this.socket = null
        }
    }

    componentWillUnmount() {
        if (this.scroller){
            clearTimeout(this.scroller)
        }
        this.clear()
    }

    button(){
        const settings = this.buttonStates[this.state.state]
        return <Button
            variant="contained"
            color="primary"
            onClick={settings.action}
        >
            {settings.label}
        </Button>
    }

    render() {
        return <div className={this.props.classes.root}>
            <Typography variant="h3">
                Send commands
                {this.button()}
                <Button
                    variant="text"
                    color="primary"
                    onClick={this.exportLogs}
                    disabled={this.state.exporting}
                >
                    {this.state.exporting ? 'Exporting TCP logs...' : 'Export TCP logs'}
                </Button>
                <Credentials deviceName={this.props.deviceName} deviceId={this.props.deviceId}/>
            </Typography>
            <Widget>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            label="Responses"
                            value={this.state.responses}
                            rows={30}
                            inputRef={this.logRef}
                            multiline
                            disabled
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={9} md={10} >
                        <TextField
                            variant="outlined"
                            label="Command"
                            value={this.state.command}
                            rows={4}
                            multiline
                            fullWidth
                            onChange={this.updateCommand}
                        />
                    </Grid>
                    <Grid item container xs={12} sm={3} md={2} justify="flex-end" alignItems="center">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.sendCommand}
                            disabled={this.state.state !== CONNECTED}
                        >
                            Send
                        </Button>
                    </Grid>
                </Grid>
            </Widget>
        </div>
    }
}

export default function({deviceId, deviceName, deviceCode}){
    const classes = useStyle(useTheme());
    return <Connection
        classes={classes}
        deviceId={deviceId}
        deviceName={deviceName}
        deviceCode={deviceCode}
    />
}
